// subtraction.js - Subtraction problem generator
import { BasicProblem } from './ui.js';
import { getRandomInt, state } from './utils.js';

export function generateSubtractionProblem(): BasicProblem {
    const type = document.querySelector<HTMLInputElement>('input[name="subtractionType"]:checked')?.value || "upTo10";

    let a, b;
    const useZero = !state.zeroUsedInWorksheet && Math.random() < 0.1;

    switch(type) {
        case 'upTo10':
            if (useZero) {
                state.zeroUsedInWorksheet = true;
                a = getRandomInt(1, 9);
                b = 0;
            } else {
                // First get the first number between 2 and 10
                a = getRandomInt(2, 10);
                // Then get a number that when subtracted from a gives a result between 0 and a
                // This means b must be between 0 and a
                b = getRandomInt(0, a);
                // If we got zero and we've already used it, or if a-b=0, try again
                if ((b === 0 && state.zeroUsedInWorksheet) || (a - b === 0)) {
                    b = getRandomInt(1, a);
                }
            }
            break;

        case 'between10and20':
            // Generate a number between 11 and 18
            a = getRandomInt(11, 18);
            // Generate a subtractor that will result in cross-ten subtraction
            b = getRandomInt(a - 10 + 1, 9);
            break;

        case 'between20and100':
            // Generate minuend between 21 and 100
            a = getRandomInt(21, 100);
            // Generate subtrahend that keeps result between 20 and 100
            b = getRandomInt(1, Math.min(a - 20, 70));
            break;

        case 'between100and1000':
            // Generate minuend between 101 and 1000
            a = getRandomInt(101, 1000);
            // Generate subtrahend that keeps result between 100 and 1000
            b = getRandomInt(1, Math.min(a - 100, 800));
            break;

        default:
            a = 2;
            b = 1;
    }

    return new BasicProblem(
        String(a).padStart(4, ' '),
        String(b).padStart(4, ' '),
        '-'
    );
}